<template>
  <transition name="slide-right">
    <v-layout raw class="main-container home">
      <pop-up-dialog-vue ref="noAttachedLicense" :key="noAttachedLicenseDialogKey" @prompt-rejected="close" :props="{
          visible: noAttachedLicenseDialog,
          message: attachLicenseToTeam,
          customActions: true,
          cancelable: true,
          persistent: false,
          visiblePropName: 'noAttachedLicenseDialog',
        }">
        <div style="padding: 0 1rem; text-align: center">
          <p>
            For assistance, please contact:
            <a style="display: block; text-align: center"
              href="mailto:support@soccerpulse.net?subject=Inactive Subscription Support">
              support@soccerpulse.net
            </a>
          </p>
        </div>
        <v-btn color="success" @click="routeTo({ name: 'ManageSubscriptions', params: { selectedTab: 1 } })"
          class="mr-2">
          Manage Licenses
        </v-btn>
      </pop-up-dialog-vue>
      <v-dialog v-model="needToCreateTeamFirstDialog" max-width="350" class="dialog-window">
        <v-card class="dialog-window-content">
          <v-card-text>
            This feature is available only after you have created a team.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" @click="$store.state.needToCreateTeamFirstDialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <v-dialog
        v-model="canJoinTeamDialog"
        max-width="350"
        class="dialog-window">
        <v-card class="dialog-window-content">
          <v-card-text>
            The Join Team feature is currently available to Players and
            Assistant Coaches only.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              @click="$store.state.canJoinTeamDialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <v-dialog v-model="dialog" max-width="350" class="dialog-window">
        <v-card class="dialog-window-content">
          <v-card-text>
            This feature is available on the SoccerPulse mobile version.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" @click="dialog = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="middle-line"></div>
      <circle-graphics :imgSrc="imgSrc" :colors="colors" :isInside="false" :styleObj="logoStyle"
        class="login-logo"></circle-graphics>
      <div class="square" :class="{ disableAnimation: isDisabled }">
        <button @click="routeTo(squadIcon)">
          <v-layout column align-center class="home-icon-top-center">
            <div class="common" :class="squadIcon.class"></div>
            <span class="text-common">{{ squadIcon.text }}</span>
          </v-layout>
        </button>
        <button @click="routeTo('ManageSquad')">
          <v-layout column align-center class="home-icon-bottom-center">
            <v-badge class="squad-badge" :content="this.joinRequests" :value="this.joinRequests"
              :color="brandColors['orange']" offset-x="24" overlap>
              <div class="manage-squad common"></div>
              <span class="text-common">
                {{ manageSquadText }}
              </span>
            </v-badge>
          </v-layout>
        </button>
        <router-link to="/injury-list">
          <v-layout column align-center class="home-icon-top-left">
            <div class="injury-list common" @click="dialog = true"></div>
            <span class="text-common darken" @click="dialog = true"> Injury List </span>
          </v-layout>
        </router-link>
        <router-link to="/team-form">
          <v-layout column align-center class="home-icon-bottom-left">
            <div class="team-form common" @click="dialog = true"></div>
            <span class="text-common darken" @click="dialog = true"> Team Form </span>
          </v-layout>
        </router-link>
        <button @click="routeTo('Events')">
          <v-layout column align-center class="home-icon-top-right">
            <div class="events common"></div>
            <span class="text-common">Events</span>
          </v-layout>
        </button>
        <router-link to="/messenger">
          <v-layout column align-center class="home-icon-bottom-right">
            <div class="messenger common" @click="dialog = true"></div>
            <span class="text-common darken" @click="dialog = true"> Messenger </span>
          </v-layout>
        </router-link>
      </div>
      <pop-up-dialog-vue v-if="this.$store.getters['user/isCoach']" ref="welcomeDialog" :props="{
          visible: this.$route.params.welcomeDialog,
          message: coachMessage,
          customActions: true,
          persistent: false,
        }">
        <v-row class="mb-3">
          <v-btn @click="routeTo('CreateTeam')" class="mr-2">Create Team</v-btn>
          <v-btn @click="routeTo('JoinTeam')">Join Team</v-btn>
        </v-row>
      </pop-up-dialog-vue>
      <pop-up-dialog-vue v-if="this.$store.getters['user/isPlayer']" ref="welcomeDialog" :props="{
          visible: this.$route.params.welcomeDialog,
          message: playerMessage,
          customActions: true,
          persistent: false,
        }">
        <v-row class="mb-3">
          <v-btn class="mr-2" @click="routeTo('JoinTeam')">Join Team</v-btn>
          <v-btn @click="dismiss()" class="mr-2">Not Now</v-btn>
        </v-row>
      </pop-up-dialog-vue>
    </v-layout>
  </transition>
</template>

<script>
import colors from "@/assets/sass/_variables.sass";
import CircleGraphics from "@/components/shared/common/cards/CircleGraphics.vue";
import PopUpDialogVue from "@/components/shared/common/cards/PopUpDialog.vue";
import { mapGetters } from "vuex";

let copyState = true;

export default {
  name: "Home",
  components: {
    PopUpDialogVue,
    // PopUpDialogVue: () => ({
    //   component: import(
    //     /* webpackChunkName: "pop-up-dialog" */ "@/components/shared/common/cards/PopUpDialog.vue"
    //   ),
    //   loading: "Loading",
    //   error: "Error",
    //   delay: 200,
    //   timeout: 2000,
    // }),
    CircleGraphics,
  },
  data() {
    return {
      brandColors: colors,
      noAttachedLicenseDialogKey: 0,
      noAttachedLicenseDialog: false,
      subRenewDialog: false,
      dialog: false,
      arKey: false,
      inactiveSubscription: false,
      coachMessage:
        "Welcome to SoccerPulse!\nYou've taken the first step in receiving actionable insights about your players' readiness, player form, injuries, availability, training load, development and more\n\nCreate a team or\njoin an existing one",
      playerMessage:
        "Welcome to SoccerPulse!\nYou've taken the first step in staying on top of team events and receiving actionable insights about your readiness, playing form, injuries, training load, development and more",
      actionRequiredMessage: "Action Required",
      attachLicenseToTeam: "",

      // color have to be arranged in the same order as the circles are referenced in the DOM
      colors: ["yellow"],
      imgSrc: require("@/assets/icons/app_login_logo.png").default,
      logoStyle: {
        "background-image": "linear-gradient(rgba(72,85,98,1), rgba(43,52,61,1))",
      },
    };
  },

  async mounted() {
    this.$store.commit("setEventListTab", "upcoming");

    setTimeout(() => {
      this.$cookie.set("disabled-animation", "1", {
        samesite: "Lax",
        secure: true,
      });
    }, 2000);
  },
  beforeDestroy() {
    clearTimeout(this.setTimeout);
    window.removeEventListener("beforeunload", this.onUnload);
  },

  methods: {
    dismiss() {
      this.$refs.welcomeDialog.dismiss();
    },
    async routeTo(route) {
      if (!this.$store?.state?.teamList?.initialized) {
        this.$toast.error(
          "There was an error loading necessary data. Please, try refreshing the page."
        );
        return;
      }
      let routeName;
      let params;
      let routerPayload;
      if (typeof route === "string") {
        routeName = route;
        routerPayload = { name: routeName };
      }
      if (typeof route === "object") {
        routeName = route.name;
        params = route.params;
        routerPayload = { name: routeName, params };
      }
      if (routeName === "JoinTeam") {
        this.$emit("show-message-dialog", {
          message: "Search for a Team",
          component: "JoinTeam",
        });
        this.dismiss();
        return;
      }
      // if this coach has a license available
      if (routeName === "CreateTeam") {
        if (this.$store.state.user.eligibleForTrial) {
          console.log("home: trial prompt");
          this.$emit("trial-prompt", true);
          this.dismiss();
          return;
        }

        if (!this.hasLicensesAvailable.length) {
          console.log("home: purchase prompt");
          this.$emit("purchase-licenses-prompt");
          this.dismiss();
          return;
        }
      }

      try {
        await this.$router.push(routerPayload);
      } catch (_e) {
        console.warn("home; navigation guard");
      }
    },
    close() {
      this.noAttachedLicenseDialog = false;
    },
    closeInactiveDialog() {
      this.$store.commit("setInactiveSubscriptionDialog", false);
    },
    checkIsActiveSubscription(to) {
      if (this.$store.state.user.hasActiveSubscription) {
        this.$router.push(to);
      }
    },
    dismissDialog() {
      this.subRenewDialogVisible = false;
      this.$store.state.inactiveSubscriptionDialog = false;
    },
    purchasePrompt() {
      this.dismissDialog();
      this.$emit("purchase-licenses-prompt", {
        dialogType: "subscriptionLapse",
        amountOfTeams: this.amountOfTeamsOwned,
        callback: "attachLicensesToExistingTeams",
      });
    },
  },

  computed: {
    ...mapGetters({
      isTeamOwner: "user/isTeamOwner",
      isCoach: "user/isCoach",
      hasLicensesAvailable: "user/availableLicenses",
      // hasActiveSubscription: "user/hasActiveSubscription",
      canCreateTeams: "user/canCreateTeam",
      activeTeam: "teamList/activeTeam",
    }),
    existingTeamsAmount() {
      return this.$store.state?.teamList?.teams?.length ?? 0;
    },
    userId() {
      return this.$store.state.user.profile.uid;
    },
    amountOfTeamsOwned() {
      let createdTeamsArr = [];
      createdTeamsArr = this.$store.state?.teamList?.teams.filter(
        (team) => team.creatorId === this.userId
      );
      return createdTeamsArr.length ?? 0;
    },
    subRenewDialogVisible: {
      get() {
        if (this.$route.params.welcomeDialog) {
          return false;
        }
        if (this.$store.overlay || this.$store.state.performingRequest) {
          return false;
        }
        if (this.$store.state.hasActiveSubscription === "pending") {
          return false;
        }
        // return !this.$store.state.hasActiveSubscription
        // TODO Performance Enhancements - Make Sure that the subscription status is ready before evaluating the sub renew dialog visibility

        if (copyState && this.isCoach) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.subRenewDialog = !this.$store.state.user.hasActiveSubscription;
          copyState = false;
        }
        return this.subRenewDialog;
      },
      set(toggleState) {
        this.subRenewDialog = toggleState;
      },
    },
    inactiveSubscriptionDialog: {
      get() {
        // return !this.hasActiveSubscription
        return this.$store.state.inactiveSubscriptionDialog;
      },
      set(val) {
        this.$store.state.inactiveSubscriptionDialog = val;
      },
    },
    needToCreateTeamFirstDialog() {
      return this.$store.state.needToCreateTeamFirstDialog;
    },
    canCreateTeamDialog() {
      return this.$store.state.canCreateTeamDialog;
    },
    canJoinTeamDialog() {
      return this.$store.state.canJoinTeamDialog;
    },
    isDisabled() {
      return true;
      // this.$cookie.get("disabled-animation")
    },
    team() {
      return this.$store.getters["teamList/activeTeam"];
    },
    // rename the prop once we include messages and other things that can increase the badge counter
    joinRequests() {
      if (!this.team) {
        return 0;
      }
      if (!this.$store.getters["user/isCoach"]) {
        return 0;
      }
      if (
        typeof this.team.joinRequests !== "string" &&
        this.team.joinRequests !== null &&
        this.team.joinRequests !== undefined
      ) {
        return Object.keys(this.team?.joinRequests).length ?? 0;
      }
      return 0;
    },

    userProfile: {
      get: function () {
        return this.$store.state.user.profile;
      },
    },
    manageSquadText() {
      if (!this.userProfile) {
        return "Squad Info";
      }
      if (this.$store.getters["user/isCoach"]) {
        return "Manage Squad";
      }
      return "Squad Info";
    },

    squadIcon() {
      if (!this.userProfile) {
        // a fallback value
        return {
          class: "squad-status-icon",
          text: "Squad Status",
          path: "/squad-status",
          name: "squad-status",
        };
      }

      if (this.$store.getters["user/isCoach"]) {
        return {
          class: "squad-status-icon",
          text: "Squad Status",
          path: "/squad-status",
          name: "squad-status",
        };
      }
      return {
        class: "user-status-icon",
        text: "My Status",
        path: `/player-status/${this.$store.state.user.current.uid}`,
        name: "PlayerStatus",
        params: { id: this.$store.state.user.current.uid },
      };
    },
  },
};
</script>

<style lang="sass">
@import '@/assets/sass/globals.sass'
.main-container.home
  overflow: hidden

.login-logo
  position: absolute
  top: 50%
  left: 50%
  transform: translateX(-50%) translateY(-50%)

.main-container
  width: 100%
  height: auto
  background:
    image: $bg-green-gradient

.middle-line
  border: 0.5px solid $white
  position: absolute
  left: 10px
  width: 98%
  top: 50%

.dialog-window
  z-index: 1000

.dialog-window-content
  padding-top: 1rem

.square
  height: 180px
  width: 180px
  margin: auto
  position: relative
  animation-name: stretch
  animation-duration: 0.5s
  animation-timing-function: ease-out
  animation-direction: alternate
  animation-fill-mode: forwards
  animation-play-state: running

  &.disableAnimation
    animation: none
    transform: scale(1.9)

.common
  width: 30px
  height: 30px
  background-size: contain
  display: flex
  align-items: flex-end
  justify-content: center

.text-common
  font:
    size: 7px
    weight: 600
  color: white

.home-icon-top-center
  position: absolute
  left: 50%
  transform: translateX(-50%)
  top: 0

.home-icon-bottom-center
  position: absolute
  left: 50%
  bottom: 0px
  transform: translateX(-50%)

.home-icon-top-left
  position: absolute
  top: 60px
  left: 20px
  transform: translateX(-50%) translateY(-50%)

.home-icon-top-right
  position: absolute
  top: 60px
  left: 160px
  transform: translateX(-50%) translateY(-50%)

.home-icon-bottom-left
  position: absolute
  top: 120px
  left: 20px
  transform: translateX(-50%) translateY(-50%)

.home-icon-bottom-right
  position: absolute
  top: 120px
  left: 160px
  transform: translateX(-50%) translateY(-50%)

.squad-status-icon
  background-image: url("../../../assets/icons/squadStatusIcon.png")

.user-status-icon
  background-image: url("../../../assets/icons/myStatusIconNew.png")

.squad-badge
  display: flex !important
  flex-direction: column !important
.manage-squad
  background-image: url("../../../assets/icons/Group.png")
  align-self: center

.injury-list
  background-image: url("../../../assets/icons/injuryListIcon.png")

.team-form
  background-image: url("../../../assets/logos/teamFormIcon.png")

.events
  background-image: url("../../../assets/icons/events_icon.png")

.messenger
  background-image: url("../../../assets/icons/messenger_icon.png")

.darken
  color: rgba(0, 0, 0, 0.5) !important

.notification-number
  left: -8px
  top: -5px

@keyframes stretch
  from
    z-index: -1
    transform: scale(0)
  to
    z-index: 1
    transform: scale(1.9)
</style>
